const clock = type => store => axios.post(`/api/clocklogs/clock-${type}`).then(res => {
        const { clocklog } = res.data.data
        store.commit('clocklog.set', clocklog)
        return clocklog
    })
export const clockIn = clock(`in`)
export const clockOut = clock(`out`)
export const clockInReminded = store => axios.post(`/api/clocklogs/reminded`).then(res => store.commit('clocklog.set', res.data.data.clocklog))
export const clocklogGetTodays = (store, item) => {
    return axios.get(`/api/clocklogs/getTodays`).then(res => {
        const { clocklog } = res.data.data
        store.commit('clocklog.set', clocklog)
        return clocklog
    })
}
export const updateClocklog = (store, item) => {
    return axios.post(`/api/clocklogs/update`, item)
}
